import React, {Component} from 'react';
import axios from 'axios';
import {connect} from "react-redux";
import css from './PhotoPack.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle, faPlus } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import { fetchS3Photos, uploadSinglePhoto } from '../../utils/awsHelper';
import PhotoGeoChecker from "../../utils/photoGeoChecker";

/**
 * @class
 *
 * PhotoPack page.
 */
const ElectricalPhotoPack = class extends Component {
    // ---------- class fields: ----------
    source = axios.CancelToken.source();
    opportunityId = this.props.opportunityId;
    sessId = this.props.sessId;
    type = this.props.type;
    s3;
    username = this.props.user.name;
    SF_DATE_TIME_FORMAT = "YYYY-MM-DDTHH:mm:ssZ";

    postRequestOpp = {
        "limit": 1,
        "skip": 0,
        "fields": [
            "Id",
            "Name",
            "Company__c",
            "Substantial__c",
            "Substantial__r.Name",
            "Ground_Mount__c",
            "Days_to_Clawback__c",
            "Site_Visits__c",
            "Location__r.Name",
            "Safe_Harbor_Needed__c"
        ],
        "where": {
            "Id": this.opportunityId
        }
    };

    postRequestSession = {
        "limit": 1,
        "skip": 0,
        "fields": [
            "Id",
            "Name",
            "Field_Job__c",
            "Assigned_Crew__r.Work_Phone_Number__c"
        ],
        "where": {
            "Id": this.sessId
        }
    };

    postRequestWorkOrder = {
        "limit": 1,
        "skip": 0,
        "fields": [
            "Id",
            "Name",
            "Assigned_Field_Team__c", 
            "Assigned_Field_Team__r.Tech_1__c",
            "Assigned_Field_Team__r.Tech_1__r.Work_Phone_Number__c",
            "Review_Submitted__c",
            "Number_of_Days__c"
        ],
        "where": {
            "Id": this.sessId
        }
    };

    state = {
        preview: false,
        previewPic: {},
        previewPics: [],
        filesToUpload: [],
        uploading: false,
        fileUploadCounter: 0,
        errorMessage: '',
        opp: {},
        session: {},
        slackResponse: '',
        sendingToSlack: false,
        tier3rtr: false,
        isPast6PM: false,
        isWorkOrder: false,

        showSafeHarborSNs: false,
        SafeHarborSNsArray:[],
        SafeHarborSNsError: false,

        ElectricalStandBack: {},
        ElectricalStandBackError: false,

        ElectricalStandBackArray: [],

        UnderEavePenetrationSealant: {},
        UnderEavePenetrationSealantError: false,

        InverterSerialModel: {},
        InverterSerialModelError: false,

        InverterWiring: {},
        InverterWiringError: false,

        VOCString: {},
        VOCStringError: false,

        VOCStringArray: [],

        ACDisconnectInterior: {},
        ACDisconnectInteriorError: false,

        ACDisconnectInteriorArray: [],

        ACDisconnectLabel: {},
        ACDisconnectLabelError: false,

        MSPPanelLabels: {},
        MSPPanelLabelsError: false,

        MSPWiring: {},
        MSPWiringError: false,

        MainBreaker: {},
        MainBreakerError: false,

        SolarBreaker: {},
        SolarBreakerError: false,

        MSPLabeledDeadfront: {},
        MSPLabeledDeadfrontError: false,

        SubPanelCombinerBox: {},
        SubPanelCombinerBoxError: false,

        SubPanelCombinerBoxArray: [],

        UFERGround: {},
        UFERGroundError: false,

        ConsumptionCT: {},
        ConsumptionCTError: false,

        CommissioningScreenshot: {},
        CommissioningScreenshotError: false,

        CommissioningScreenshotArray: [],

        WarningSticker: {},
        WarningStickerError: false,

        CellularKitWiring: {},
        CellularKitWiringError: false,
        
        UtilityProductionMeters: {},
        UtilityProductionMetersError: false,

        EGCPathtoGround: {},
        EGCPathtoGroundError: false,

        EGCPathtoGroundArray: [],

        ProductionMeter: {},
        ProductionMeterError: false,

        ProductionMeterArray: [],

        ProductionMeterSerialNumber: {},
        ProductionMeterSerialNumberError: false,

        SolarEdgeRGMInverter: {},
        SolarEdgeRGMInverterError: false,

        CADChanges: {},
        CADChangesError: false,
        CADChangesArray: [],

        WireSize: {},
        WireSizeError: false
    }

    // ---------- life cycle methods: ----------
    async componentDidMount() {
        window.scrollTo(0, 0);

        fetchS3Photos({
            recordId: this.opportunityId,
            type: '/' + this.type,
            process: 'getDocs',
            existingState: this.state,
            source: this.source
        })
        .then(newState => {
            this.setState(newState);
        })
        .catch(err => {
            console.error('AWS S3 fetch error:', err);
            this.setState({ errorMessage: err.message });
        });

        const now = new Date();
        const pstTime = moment(now, "America/Los_Angeles");
        if (pstTime.hour() >= 18) {
            this.setState({ isPast6PM: true });
        }

        await this.getOpp();

        const isWorkOrder = this.sessId.startsWith('a0j');
        this.setState({ isWorkOrder });

        if (isWorkOrder) {
            await this.getWorkOrder();
        } else {
            await this.getSession();
        }
    }

    componentWillUnmount() {
        this.source.cancel();
    }

    getOpp = async() => {
        axios.post(
            '/sf/opportunity/findNo',
            this.postRequestOpp,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const data = res.data.records[0];
                this.setState({opp: data});

                if((data.Days_to_Clawback__c !== null && data.Days_to_Clawback__c < 30) || data.Site_Visits__c >= 6) {
                    this.setState({tier3rtr: true});
                }

                if(data.Safe_Harbor_Needed__c !== null){
                    this.setState({showSafeHarborSNs: true});
                }
            })
            .catch(err => console.log('POST Error Opp:\n', err));
    };

    getSession = async() => {
        axios.post(
            '/sf/schedulable/findNo',
            this.postRequestSession,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const data = res.data.records[0];

                this.setState({session: data});
            })
            .catch(err => console.log('POST Error Session:\n', err));
    };

    getWorkOrder = async() => {
        axios.post(
            '/sf/WorkOrder/findNo',
            this.postRequestWorkOrder,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const data = res.data.records[0];

                this.setState({session: data});
            })
            .catch(err => console.log('POST Error Session:\n', err));
    }

    capturePhoto = async(file, stateName, stateNameError) => {
        if (!file || this.state.uploading) return;
        
        try {
            await uploadSinglePhoto({
                file,
                stateName,
                stateNameError,
                username: this.username,
                opportunityId: this.opportunityId,
                type: this.type,
                setState: this.setState.bind(this),
                source: this.source
            });
        } catch(err){
            console.log(err)
        }
    };

    bulkUpload = async (files, arrayName, picNames, stateNameError) => {
        const currentArray = this.state[arrayName] || [];
        const updatedArray = [...currentArray];
        const filesToUploadArray = [];

        let existingSizes = new Set();
        let safeHarborPhotosUploaded = false;

        // Only run duplicate-by-size logic for SafeHarborSNsArray
        if(arrayName === 'SafeHarborSNsArray' && currentArray.length > 0) {
            try {
                for(let i = 0; i < currentArray.length; i++) {
                    try {
                        const exisitingUrl = this.state[currentArray[i]];
                        const key = exisitingUrl.split('https://v3-portal-file-storage.s3.us-west-2.amazonaws.com/');

                        const payload = {
                            method: 'HEAD',
                            process: 'getUrl',
                            bucket: 'v3-portal-file-storage',
                            key: key[1],
                            expiresSec: 60,
                            RecordId: this.opportunityId
                        };

                        const res = await axios.post('/postAWS', payload, { cancelToken: this.source.token });
                        const url = res?.data?.key;
                        if (!url) throw new Error('Missing presigned URL');
                        const headRes = await fetch(url, { method: 'HEAD' });

                        if (!headRes.ok) {
                            throw new Error(`HEAD ${headRes.status} ${headRes.statusText}`);
                        }

                        const len = headRes.headers.get('content-length');
                        if (len) existingSizes.add(Number(len));
                    } catch (err) {
                        console.error('Presigned HEAD check failed:', err);
                    }
                }
            } catch (err) {
                console.error('Failed to fetch existing photos:', err);
            }
        }

        const skippedFiles = [];
        for(const file of files) {
            if(arrayName === 'SafeHarborSNsArray'){
                const fileSize = Number(file.size);
                if(existingSizes.has(fileSize)) {
                    skippedFiles.push({ name: file.name, reason: 'Duplicate Photo'});
                    continue;
                }

                const hasGeotag = await PhotoGeoChecker.hasGeo(file);
                if(!hasGeotag) {
                    skippedFiles.push({ name: file.name, reason: 'No Geotag Found'});
                    continue
                }

                // setting to true if there was at least one SH photo that passed both duplicate and geotag validation.
                safeHarborPhotosUploaded = true;
            }

            filesToUploadArray.push(file);
        }

        this.setState({
            bulkUploading: true,
            uploadProgress: { done: 0, total: filesToUploadArray.length },
            errorMessage: ''
        });

        let nextNumber = updatedArray.length + 1;

        try {
            for (const file of filesToUploadArray) {
                const picName = `${picNames}${nextNumber}`;

                try {
                    await this.capturePhoto(file, picName, stateNameError);
                    updatedArray.push(picName);
                    nextNumber++;
                } catch (err) {
                    console.error(`Failed to upload ${picName}:`, err);
                } finally {
                    // update progress after each attempt
                    this.setState(prev => ({
                        uploadProgress: {
                            done: Math.min((prev.uploadProgress?.done || 0) + 1, filesToUploadArray.length),
                            total: filesToUploadArray.length
                        }
                    }));
                }
            }
            this.setState({ [arrayName]: updatedArray });
        } finally {
            this.setState({ bulkUploading: false });
        }

        if(skippedFiles.length > 0) {
            const message =
                `These files were not uploaded:\n` +
                skippedFiles.map((f) => `- "${f.name}", reason: "${f.reason}"`).join('\n');
            this.setState({ errorMessage: message });
        }

        if(safeHarborPhotosUploaded) {
            try {
                await axios.put('/sf/WorkOrder/update', {
                    Id: this.sessId,
                    Safe_Harbor_SNs_Photos_Uploaded__c: moment().format('YYYY-MM-DDTHH:mm:ssZ'),
                });
            } catch (err) {
                console.log('PUT Error Work Order:\n', err);
            }
        }
    };

    previewImage = (e) => {
        let img = e;
        this.setState({previewPic: img, preview:true});
    };

    addAnotherPic = (array, fileName, displayName) => {
        let picNumber = this.state[array].length + 1;
        let stateName = fileName + picNumber.toString()
        this.setState({
            [array]: [...this.state[array], stateName],
            [stateName] : {}
        })
    };

    sendToSlack = () => {
        this.setState({sendingToSlack: true});

        let message = 'Solar Electrical Photos Review for: <https://v3electric.my.site.com/frontendOps/s/detail/' +  this.state.opp.Id + '|' +  this.state.opp.Name +'>\n' +
            'Field Tech: ' + this.props.user.name + '\n' +
            'Photo Pack Page: <https://v3electric.my.site.com/frontendOps/s/sfdcpage/%2Fapex%2FPhotoPackOppS3%3F%26id%3D' + this.state.opp.Id + '|Photo Pack>\n' +
            'Work Order: <https://v3electric.my.site.com/frontendOps/s/detail/' + this.state.session.Id + '|' +  this.state.session.Name +'>\n' +
            'Substantial: <https://v3electric.my.site.com/frontendOps/s/detail/' + this.state.opp.Substantial__c + '|' +  this.state.opp.Substantial__r.Name +'>\n' +
            'Financier: ' + this.state.opp.Company__c + '\n' +
            'Location: ' + this.state.opp.Location__r.Name + '\n' +
            'Number of Days: ' + this.state.session.Number_of_Days__c;

        // test-api channel id C06JN84MGFM
        // tier 1 rtr id: C07UMTF64TE
        // tier 2 rtr id: C07UGHTQ7M3
        // tier 3 rtr id: C07V87JGTFS

        let channelId = '';

        if((this.state.opp.Days_to_Clawback__c > 30 || this.state.opp.Days_to_Clawback__c === null) && this.state.opp.Site_Visits__c < 6){
            channelId = 'C07UMTF64TE'; // tier 1
        } else if((this.state.opp.Days_to_Clawback__c !== null && this.state.opp.Days_to_Clawback__c < 30) || this.state.opp.Site_Visits__c >= 6) {
            channelId = 'C07V87JGTFS'; // tier 3
            if(this.state.isWorkOrder){
                message = message + '\nTechs Work Phone Number: ' + this.state.session.Assigned_Field_Team__r.Tech_1__r.Work_Phone_Number__c;
            } else {
                message = message + '\nTechs Work Phone Number: ' + this.state.session.Assigned_Crew__r.Work_Phone_Number__c;
            }
        } else {
            channelId = 'C07UMTF64TE'; // default to tier 1
        }

        let payload = {
            "channel": channelId,
            "text": message
        };

        axios.post(
            '/slackMessage', 
            payload,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                this.setState({slackResponse: 'Notification sent to Slack successfully', sendingToSlack: false});

                let subPayload = {
                    Id: this.state.opp.Substantial__c,
                    Solar_Electrical_Review_SubmittedDT__c: moment()
                };

                axios.put(
                    '/sf/substantial/update',
                    subPayload,
                    {
                        cancelToken: this.source.token
                    }).then((res) => {
                        
                    })
                    .catch(err => console.log('PUT Error updating substantial:\n', err))

                // Review Submitted on WO is used for reporting on when field team initially requested RTR.
                if(this.state.isWorkOrder && !this.state.session.Review_Submitted__c){
                    let woPayload = {
                        Id: this.sessId,
                        Review_Submitted__c: moment().format('YYYY-MM-DDTHH:mm:ssZ'),
                    };

                    axios.put(
                        '/sf/WorkOrder/update', 
                        woPayload, 
                        {
                            cancelToken: this.source.token
                        })
                        .catch(err => console.log('PUT Error Updating WO on RTR Request:\n', err));
                }

                setTimeout(() => {
                    this.setState({slackResponse: ''});
                }, 3000);
            })
            .catch(err => {
                console.log('POST Error Sending Slack Message:\n', err);
                this.setState({slackResponse: 'Failed to send to Slack: ' + err.message, sendingToSlack: false});
            });
    };

    render() {
        return (
            <div className={css.PhotoPack}>
                <h1 className='pb-3'>Solar {this.type} Photo Pack</h1>
                <h2 className='text-white pb-3'>Please Ensure HEIC is turned off as the format isn't readily sharable</h2>
                <h2 className={this.state.errorMessage !== '' ? 'text-error' : 'd-none'} style={{ whiteSpace: 'pre-line' }}>Error: {this.state.errorMessage}</h2>
                
                {
                    this.state.preview ? 
                    <div>
                        <div>
                            <img className={css.PhotoPack__PreviewImg} src={this.state.previewPic} alt="Preview of upload" />
                        </div>
                        <div className='pt-3'>
                            <button className='btn btn-primary' onClick={() => this.setState({preview: false, previewPic: {}})}>Close Preview</button>
                        </div>
                    </div>

                    :

                    <div>
                        {/* Slack div to send messages */}
                        <div className='py-3'>
                            <button className='btn btn-primary' disabled={this.state.sendingToSlack} onClick={() => this.sendToSlack()}>Notify Office for Review</button>
                        </div>
                        <div className={this.state.slackResponse !== '' ? 'py-3' : 'd-none'}>
                            <p className='text-white'>{this.state.slackResponse}</p>
                        </div>
                        <div className={this.state.sendingToSlack ? 'py-3' : 'd-none'}>
                            <div className={css.PhotoPack__Loader}></div>
                        </div>
                        {
                            this.state.tier3rtr ? 
                                this.state.isPast6PM ? 
                                <h2 className='text-white pb-3'>This is a Tier 3 project. Reviewers are unavailable at this time. Please be prepared to have a phone review tomorrow morning.</h2>
                                :
                                <h2 className='text-white pb-3'>This is a Tier 3 project. Please sit tight until you receive a call from the RTR team to conduct the review.</h2>
                                :
                                <></>
                        }

                        <table>
                            <tbody>
                                {/* Safe Harbor Serial Number(s) */}
                                <tr className={(this.state.showSafeHarborSNs || this.state.SafeHarborSNsArray && this.state.SafeHarborSNsArray.length !== 0) ?  "" : "d-none"}>
                                    <td className="w-50">
                                        {
                                        this.state.SafeHarborSNsError ?
                                        <div className='text-error'>
                                            <FontAwesomeIcon icon={faCircle} /> Error Uploading Safe Harbor Serial Number(s): <br />{this.state.errorMessage}
                                        </div>
                                        :
                                        <div className='text-warningC'>
                                            <FontAwesomeIcon icon={faCircle} /> Safe Harbor Serial Number(s)
                                        </div>
                                        }
                                    </td>
                                    <td className="w-25">
                                        <label htmlFor="SafeHarborSNsUpload" className="btn btn-primary">
                                            <div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>
                                            Bulk Upload
                                        </label>
                                        <input
                                            className={css.PhotoPack__PicInput}
                                            id="SafeHarborSNsUpload"
                                            type="file"
                                            accept="image/*"
                                            disabled={this.state.uploading}
                                            multiple
                                            onChange={(event) => this.bulkUpload(
                                                event.target.files,
                                                'SafeHarborSNsArray',
                                                'SafeHarborSNs-',
                                                'SafeHarborSNsError'
                                            )}
                                        />
                                    </td>
                                    <td></td>
                                </tr>

                                {
                                this.state.SafeHarborSNsArray && this.state.SafeHarborSNsArray.length !== 0 ?
                                    this.state.SafeHarborSNsArray.map(t =>
                                        <tr key={t}>
                                        <td className="w-50">
                                            {
                                            Object.keys(this.state[t] || {}).length === 0
                                            ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> {t}</div>
                                            :
                                            <button
                                                className='btn btn-outline text-green btn-text'
                                                onClick={() => this.previewImage(this.state[t])}
                                            >
                                                <FontAwesomeIcon icon={faCircle} /> {t}
                                            </button>
                                            }
                                        </td>
                                        <td></td>
                                        <td></td>
                                        </tr>
                                    )
                                :
                                    <></>
                                }

                                {/* Electrical Stand Back Photos */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.ElectricalStandBack).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Electrical Stand Back: Photo of all electrical equipment and conduit path from roof to the MSP. Take from multiple angles </div>
                                            :
                                            this.state.ElectricalStandBackError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Electrical Stand Back: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.ElectricalStandBack)}><FontAwesomeIcon icon={faCircle} /> Electrical Stand Back: Photo of all electrical equipment and conduit path from roof to the MSP. Take from multiple angles </button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="ElectricalStandBack" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="ElectricalStandBack" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'ElectricalStandBack', 'ElectricalStandBackError')} /></td>
                                    <td className="w-25"><label for="ElectricalStandBackUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="ElectricalStandBackUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'ElectricalStandBack', 'ElectricalStandBackError')}/></td>
                                </tr>

                                {/* Electrical Stand Back Array Photos */}
                                {
                                    this.state.ElectricalStandBackArray.length !== 0 ? 
                                    
                                    this.state.ElectricalStandBackArray.map(t =>
                                        <tr>
                                            <td className="w-50">
                                                {
                                                    Object.keys(this.state[t]).length === 0 ?
                                                    <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> {t}</div>
                                                    :
                                                    <button className='btn btn-outline text-green btn-text' onClick={() => this.previewImage(this.state[t])}><FontAwesomeIcon icon={faCircle} /> {t}</button>
                                                }
                                            </td>
                                            <td className="w-25"><label for={t} class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id={t} type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], t)} /></td>
                                            <td className="w-25"><label for={t + 'Upload'} class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id={t + 'Upload'} type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], t)}/></td>
                                        </tr>
                                    )
                                    :
                                    <></>
                                }
                                <tr>
                                    <td className="w-50">Add Another Electrical Stand Back Pic</td>
                                    <td className="w-25"><button className='btn btn-primary' onClick={() => this.addAnotherPic('ElectricalStandBackArray', 'ElectricalStandBack-', '')}>Add <FontAwesomeIcon icon={faPlus} /></button></td>
                                    <td className="w-25"></td>
                                </tr>

                                {/* Under Eave Penetration Sealant Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.UnderEavePenetrationSealant).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Under Eave Penetration Sealant </div>
                                            :
                                            this.state.UnderEavePenetrationSealantError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading : <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.UnderEavePenetrationSealant)}><FontAwesomeIcon icon={faCircle} /> Under Eave Penetration Sealant </button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="UnderEavePenetrationSealant" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="UnderEavePenetrationSealant" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'UnderEavePenetrationSealant', 'UnderEavePenetrationSealantError')} /></td>
                                    <td className="w-25"><label for="UnderEavePenetrationSealantUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="UnderEavePenetrationSealantUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'UnderEavePenetrationSealant', 'UnderEavePenetrationSealantError')}/></td>
                                </tr>

                                {/* Inverter Serial Number And Model Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.InverterSerialModel).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Inverter Serial Number & Model: Sticker located on the top right of the inverter</div>
                                            :
                                            this.state.InverterSerialModelError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Inverter Serial Number & Model: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.InverterSerialModel)}><FontAwesomeIcon icon={faCircle} /> Inverter Serial Number & Model: Sticker located on the top right of the inverter</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="InverterSerialModel" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="InverterSerialModel" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'InverterSerialModel', 'InverterSerialModelError')} /></td>
                                    <td className="w-25"><label for="InverterSerialModelUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="InverterSerialModelUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'InverterSerialModel', 'InverterSerialModelError')}/></td>
                                </tr>

                                {/* Inverter Wiring Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.InverterWiring).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Inverter Wiring: Completed wiring with entry points properly grounded and GSM installed. Photo should show wiring of the top and bottom</div>
                                            :
                                            this.state.InverterWiringError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Inverter Wiring: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.InverterWiring)}><FontAwesomeIcon icon={faCircle} /> Inverter Wiring: Completed wiring with entry points properly grounded and GSM installed. Photo should show wiring of the top and bottom</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="InverterWiring" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="InverterWiring" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'InverterWiring', 'InverterWiringError')} /></td>
                                    <td className="w-25"><label for="InverterWiringUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="InverterWiringUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'InverterWiring', 'InverterWiringError')}/></td>
                                </tr>

                                {/* VOC String Photos */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.VOCString).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> VOC String Measurements: No less than 8 panels per string and no more than 15</div>
                                            :
                                            this.state.VOCStringError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading VOC String Measurements: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.VOCString)}><FontAwesomeIcon icon={faCircle} /> VOC String Measurements: No less than 8 panels per string and no more than 15</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="VOCString" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="VOCString" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'VOCString', 'VOCStringError')} /></td>
                                    <td className="w-25"><label for="VOCStringUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="VOCStringUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'VOCString', 'VOCStringError')}/></td>
                                </tr>

                                {/* VOC String Array Photos */}
                                {
                                    this.state.VOCStringArray.length !== 0 ? 
                                    
                                    this.state.VOCStringArray.map(t =>
                                        <tr>
                                            <td className="w-50">
                                                {
                                                    Object.keys(this.state[t]).length === 0 ?
                                                    <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> {t}</div>
                                                    :
                                                    <button className='btn btn-outline text-green btn-text' onClick={() => this.previewImage(this.state[t])}><FontAwesomeIcon icon={faCircle} /> {t}</button>
                                                }
                                            </td>
                                            <td className="w-25"><label for={t} class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id={t} type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], t)} /></td>
                                            <td className="w-25"><label for={t + 'Upload'} class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id={t + 'Upload'} type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], t)}/></td>
                                        </tr>
                                    )
                                    :
                                    <></>
                                }
                                <tr>
                                    <td className="w-50">Add Another VOC String Pic</td>
                                    <td className="w-25"><button className='btn btn-primary' onClick={() => this.addAnotherPic('VOCStringArray', 'VOCString-', '')}>Add <FontAwesomeIcon icon={faPlus} /></button></td>
                                    <td className="w-25"></td>
                                </tr>

                                {/* AC Disconnect Interior Photos */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.ACDisconnectInterior).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> AC Disconnect Interior: Photo of completed wiring(red wires on the right). Need a clear photo of the fuse amp ratings if a fused disconnect</div>
                                            :
                                            this.state.ACDisconnectInteriorError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading AC Disconnect Interior: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.ACDisconnectInterior)}><FontAwesomeIcon icon={faCircle} /> AC Disconnect Interior: Photo of completed wiring(red wires on the right). Need a clear photo of the fuse amp ratings if a fused disconnect</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="ACDisconnectInterior" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="ACDisconnectInterior" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'ACDisconnectInterior', 'ACDisconnectInteriorError')} /></td>
                                    <td className="w-25"><label for="ACDisconnectInteriorUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="ACDisconnectInteriorUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'ACDisconnectInterior', 'ACDisconnectInteriorError')}/></td>
                                </tr>

                                {/* AC Disconnect Interior Array Photos */}
                                {
                                    this.state.ACDisconnectInteriorArray.length !== 0 ? 
                                    
                                    this.state.ACDisconnectInteriorArray.map(t =>
                                        <tr>
                                            <td className="w-50">
                                                {
                                                    Object.keys(this.state[t]).length === 0 ?
                                                    <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> {t}</div>
                                                    :
                                                    <button className='btn btn-outline text-green btn-text' onClick={() => this.previewImage(this.state[t])}><FontAwesomeIcon icon={faCircle} /> {t}</button>
                                                }
                                            </td>
                                            <td className="w-25"><label for={t} class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id={t} type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], t)} /></td>
                                            <td className="w-25"><label for={t + 'Upload'} class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id={t + 'Upload'} type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], t)}/></td>
                                        </tr>
                                    )
                                    :
                                    <></>
                                }
                                <tr>
                                    <td className="w-50">Add Another AC Disconnect Interior Pic</td>
                                    <td className="w-25"><button className='btn btn-primary' onClick={() => this.addAnotherPic('ACDisconnectInteriorArray', 'ACDisconnectInterior-', '')}>Add <FontAwesomeIcon icon={faPlus} /></button></td>
                                    <td className="w-25"></td>
                                </tr>

                                {/* AC Disconnect Label Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.ACDisconnectLabel).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> AC Disconnect Label:  Big sticker on the inside of the door. ACD model and Amp rating must be clear</div>
                                            :
                                            this.state.ACDisconnectLabelError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading AC Disconnect Label: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.ACDisconnectLabel)}><FontAwesomeIcon icon={faCircle} /> AC Disconnect Label:  Big sticker on the inside of the door. ACD model and Amp rating must be clear</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="ACDisconnectLabel" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="ACDisconnectLabel" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'ACDisconnectLabel', 'ACDisconnectLabelError')} /></td>
                                    <td className="w-25"><label for="ACDisconnectLabelUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="ACDisconnectLabelUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'ACDisconnectLabel', 'ACDisconnectLabelError')}/></td>
                                </tr>

                                {/* MSP Panel Labels Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.MSPPanelLabels).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> MSP Panel Labels w/ Bus Ratings: Bus ratings must be legible and accurate to the plans. If no MSP label is available, the main breaker rating will be counted as the bus rating</div>
                                            :
                                            this.state.MSPPanelLabelsError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading MSP Panel Labels w/ Bus Ratings: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.MSPPanelLabels)}><FontAwesomeIcon icon={faCircle} /> MSP Panel Labels w/ Bus Ratings: Bus ratings must be legible and accurate to the plans. If no MSP label is available, the main breaker rating will be counted as the bus rating</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="MSPPanelLabels" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="MSPPanelLabels" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'MSPPanelLabels', 'MSPPanelLabelsError')} /></td>
                                    <td className="w-25"><label for="MSPPanelLabelsUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="MSPPanelLabelsUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'MSPPanelLabels', 'MSPPanelLabelsError')}/></td>
                                </tr>

                                {/* MSP Wiring Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.MSPWiring).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> MSP Wiring: Completed MSP wiring with all breakers, power blocks, main breaker installed.</div>
                                            :
                                            this.state.MSPWiringError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading MSP Wiring: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.MSPWiring)}><FontAwesomeIcon icon={faCircle} /> MSP Wiring: Completed MSP wiring with all breakers, power blocks, main breaker installed.</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="MSPWiring" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="MSPWiring" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'MSPWiring', 'MSPWiringError')} /></td>
                                    <td className="w-25"><label for="MSPWiringUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="MSPWiringUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'MSPWiring', 'MSPWiringError')}/></td>
                                </tr>

                                {/* Main Breaker Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.MainBreaker).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Main Breaker: Close up photo of main breaker with the rating clearly visible</div>
                                            :
                                            this.state.MainBreakerError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Main Breaker: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.MainBreaker)}><FontAwesomeIcon icon={faCircle} /> Main Breaker: Close up photo of main breaker with the rating clearly visible</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="MainBreaker" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="MainBreaker" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'MainBreaker', 'MainBreakerError')} /></td>
                                    <td className="w-25"><label for="MainBreakerUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="MainBreakerUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'MainBreaker', 'MainBreakerError')}/></td>
                                </tr>

                                {/* Solar Breaker Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.SolarBreaker).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Solar Breaker: Close up photo of the solar breaker (may be in main breaker or other sub panel)</div>
                                            :
                                            this.state.SolarBreakerError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Solar Breaker: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.SolarBreaker)}><FontAwesomeIcon icon={faCircle} /> Solar Breaker: Close up photo of the solar breaker (may be in main breaker or other sub panel)</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="SolarBreaker" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="SolarBreaker" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'SolarBreaker', 'SolarBreakerError')} /></td>
                                    <td className="w-25"><label for="SolarBreakerUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="SolarBreakerUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'SolarBreaker', 'SolarBreakerError')}/></td>
                                </tr>

                                {/* MSP Labeled Deadfront Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.MSPLabeledDeadfront).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> MSP Labeled Deadfront: All breakers must be labeled including any existing solar.</div>
                                            :
                                            this.state.MSPLabeledDeadfrontError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading MSP Labeled Deadfront: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.MSPLabeledDeadfront)}><FontAwesomeIcon icon={faCircle} /> MSP Labeled Deadfront: All breakers must be labeled including any existing solar.</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="MSPLabeledDeadfront" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="MSPLabeledDeadfront" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'MSPLabeledDeadfront', 'MSPLabeledDeadfrontError')} /></td>
                                    <td className="w-25"><label for="MSPLabeledDeadfrontUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="MSPLabeledDeadfrontUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'MSPLabeledDeadfront', 'MSPLabeledDeadfrontError')}/></td>
                                </tr>

                                {/* Sub Panel Combiner Box Photos */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.SubPanelCombinerBox).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Sub Panel/Combiner Box (if applicable): Panel label, completed wiring, up close for solar and main breakers, deadfront on and labeled.</div>
                                            :
                                            this.state.SubPanelCombinerBoxError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Sub Panel/Combiner Box: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.SubPanelCombinerBox)}><FontAwesomeIcon icon={faCircle} /> Sub Panel/Combiner Box (if applicable): Panel label, completed wiring, up close for solar and main breakers, deadfront on and labeled.</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="SubPanelCombinerBox" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="SubPanelCombinerBox" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'SubPanelCombinerBox', 'SubPanelCombinerBoxError')} /></td>
                                    <td className="w-25"><label for="SubPanelCombinerBoxUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="SubPanelCombinerBoxUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'SubPanelCombinerBox', 'SubPanelCombinerBoxError')}/></td>
                                </tr>

                                {/* Sub Panel Combiner Box Array Photos */}
                                {
                                    this.state.SubPanelCombinerBoxArray.length !== 0 ? 
                                    
                                    this.state.SubPanelCombinerBoxArray.map(t =>
                                        <tr>
                                            <td className="w-50">
                                                {
                                                    Object.keys(this.state[t]).length === 0 ?
                                                    <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> {t}</div>
                                                    :
                                                    <button className='btn btn-outline text-green btn-text' onClick={() => this.previewImage(this.state[t])}><FontAwesomeIcon icon={faCircle} /> {t}</button>
                                                }
                                            </td>
                                            <td className="w-25"><label for={t} class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id={t} type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], t)} /></td>
                                            <td className="w-25"><label for={t + 'Upload'} class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id={t + 'Upload'} type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], t)}/></td>
                                        </tr>
                                    )
                                    :
                                    <></>
                                }
                                <tr>
                                    <td className="w-50">Add Another Sub Panel Combiner Box Pic</td>
                                    <td className="w-25"><button className='btn btn-primary' onClick={() => this.addAnotherPic('SubPanelCombinerBoxArray', 'SubPanelCombinerBox-', '')}>Add <FontAwesomeIcon icon={faPlus} /></button></td>
                                    <td className="w-25"></td>
                                </tr>

                                {/* UFER Ground Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.UFERGround).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> UFER Ground: Irreversible crimp connecting ground wire to the main panel grounding</div>
                                            :
                                            this.state.UFERGroundError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading UFER Ground: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.UFERGround)}><FontAwesomeIcon icon={faCircle} /> UFER Ground: Irreversible crimp connecting ground wire to the main panel grounding</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="UFERGround" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="UFERGround" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'UFERGround', 'UFERGroundError')} /></td>
                                    <td className="w-25"><label for="UFERGroundUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="UFERGroundUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'UFERGround', 'UFERGroundError')}/></td>
                                </tr>

                                {/* Consumption CTs Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.ConsumptionCT).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Consumption CTs: When applicable</div>
                                            :
                                            this.state.ConsumptionCTError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Consumption CTs: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.ConsumptionCT)}><FontAwesomeIcon icon={faCircle} /> Consumption CTs: When applicable</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="ConsumptionCT" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="ConsumptionCT" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'ConsumptionCT', 'ConsumptionCTError')} /></td>
                                    <td className="w-25"><label for="ConsumptionCTUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="ConsumptionCTUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'ConsumptionCT', 'ConsumptionCTError')}/></td>
                                </tr>

                                {/* Commissioning Screenshot Photos */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.CommissioningScreenshot).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Commissioning Screenshots: Must show all panels, S-OK Cellular and country set to Rule 21 240V. If CTs are not installed, the meter to inverter must be set to production only.</div>
                                            :
                                            this.state.CommissioningScreenshotError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Commissioning Screenshots: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.CommissioningScreenshot)}><FontAwesomeIcon icon={faCircle} /> Commissioning Screenshots: Must show all panels, S-OK Cellular and country set to Rule 21 240V. If CTs are not installed, the meter to inverter must be set to production only.</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="CommissioningScreenshot" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="CommissioningScreenshot" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'CommissioningScreenshot', 'CommissioningScreenshotError')} /></td>
                                    <td className="w-25"><label for="CommissioningScreenshotUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="CommissioningScreenshotUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'CommissioningScreenshot', 'CommissioningScreenshotError')}/></td>
                                </tr>

                                {/* Commissioning Screenshot Array Photos */}
                                {
                                    this.state.CommissioningScreenshotArray.length !== 0 ? 
                                    
                                    this.state.CommissioningScreenshotArray.map(t =>
                                        <tr>
                                            <td className="w-50">
                                                {
                                                    Object.keys(this.state[t]).length === 0 ?
                                                    <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> {t}</div>
                                                    :
                                                    <button className='btn btn-outline text-green btn-text' onClick={() => this.previewImage(this.state[t])}><FontAwesomeIcon icon={faCircle} /> {t}</button>
                                                }
                                            </td>
                                            <td className="w-25"><label for={t} class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id={t} type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], t)} /></td>
                                            <td className="w-25"><label for={t + 'Upload'} class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id={t + 'Upload'} type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], t)}/></td>
                                        </tr>
                                    )
                                    :
                                    <></>
                                }
                                <tr>
                                    <td className="w-50">Add Another Commissioning Screenshot Pic</td>
                                    <td className="w-25"><button className='btn btn-primary' onClick={() => this.addAnotherPic('CommissioningScreenshotArray', 'CommissioningScreenshot-', '')}>Add <FontAwesomeIcon icon={faPlus} /></button></td>
                                    <td className="w-25"></td>
                                </tr>

                                {/* Warning Sticker Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.WarningSticker).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> “Do not add loads sticker” Required when all breakers on MSP are moved to a backup sub and no more breakers can be installed on MSP.</div>
                                            :
                                            this.state.WarningStickerError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Do not add loads sticker: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.WarningSticker)}><FontAwesomeIcon icon={faCircle} /> “Do not add loads sticker” Required when all breakers on MSP are moved to a backup sub and no more breakers can be installed on MSP.</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="WarningSticker" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="WarningSticker" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'WarningSticker', 'WarningStickerError')} /></td>
                                    <td className="w-25"><label for="WarningStickerUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="WarningStickerUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'WarningSticker', 'WarningStickerError')}/></td>
                                </tr>

                                {/* Cellular Kit Wiring or Plug In Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.CellularKitWiring).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Cellular Kit Wiring or Plug In (IQ Combiner/SolarEdge upper cabinet)</div>
                                            :
                                            this.state.CellularKitWiringError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Cellular Kit Wiring or Plug In: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.CellularKitWiring)}><FontAwesomeIcon icon={faCircle} /> Cellular Kit Wiring or Plug In (IQ Combiner/SolarEdge upper cabinet)</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="CellularKitWiring" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="CellularKitWiring" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'CellularKitWiring', 'CellularKitWiringError')} /></td>
                                    <td className="w-25"><label for="CellularKitWiringUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="CellularKitWiringUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'CellularKitWiring', 'CellularKitWiringError')}/></td>
                                </tr>

                                {/* Utility Production Meters Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.UtilityProductionMeters).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Utility Production Meters (Interior wiring and terminations)</div>
                                            :
                                            this.state.UtilityProductionMetersError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Utility Production Meters: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.UtilityProductionMeters)}><FontAwesomeIcon icon={faCircle} /> Utility Production Meters (Interior wiring and terminations)</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="UtilityProductionMeters" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="UtilityProductionMeters" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'UtilityProductionMeters', 'UtilityProductionMetersError')} /></td>
                                    <td className="w-25"><label for="UtilityProductionMetersUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="UtilityProductionMetersUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'UtilityProductionMeters', 'UtilityProductionMetersError')}/></td>
                                </tr>

                                {/* EGC Path to Ground Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.EGCPathtoGround).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> EGC Path to Ground</div>
                                            :
                                            this.state.EGCPathtoGroundError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading EGC Path to Ground: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.EGCPathtoGround)}><FontAwesomeIcon icon={faCircle} /> EGC Path to Ground</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="EGCPathtoGround" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="EGCPathtoGround" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'EGCPathtoGround', 'EGCPathtoGroundError')} /></td>
                                    <td className="w-25"><label for="EGCPathtoGroundUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="EGCPathtoGroundUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'EGCPathtoGround', 'EGCPathtoGroundError')}/></td>
                                </tr>

                                {/* EGC Path to Ground Array Photos */}
                                {
                                    this.state.EGCPathtoGroundArray.length !== 0 ? 
                                    
                                    this.state.EGCPathtoGroundArray.map(t =>
                                        <tr>
                                            <td className="w-50">
                                                {
                                                    Object.keys(this.state[t]).length === 0 ?
                                                    <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> {t}</div>
                                                    :
                                                    <button className='btn btn-outline text-green btn-text' onClick={() => this.previewImage(this.state[t])}><FontAwesomeIcon icon={faCircle} /> {t}</button>
                                                }
                                            </td>
                                            <td className="w-25"><label for={t} class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id={t} type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], t)} /></td>
                                            <td className="w-25"><label for={t + 'Upload'} class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id={t + 'Upload'} type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], t)}/></td>
                                        </tr>
                                    )
                                    :
                                    <></>
                                }
                                <tr>
                                    <td className="w-50">Add Another EGC Path to Ground Pic</td>
                                    <td className="w-25"><button className='btn btn-primary' onClick={() => this.addAnotherPic('EGCPathtoGroundArray', 'EGCPathtoGround-', '')}>Add <FontAwesomeIcon icon={faPlus} /></button></td>
                                    <td className="w-25"></td>
                                </tr>

                                {/* Production Meter Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.ProductionMeter).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Production Meter</div>
                                            :
                                            this.state.ProductionMeterError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Production Meter: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.ProductionMeter)}><FontAwesomeIcon icon={faCircle} /> Production Meter</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="ProductionMeter" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="ProductionMeter" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'ProductionMeter', 'ProductionMeterError')} /></td>
                                    <td className="w-25"><label for="ProductionMeterUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="ProductionMeterUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'ProductionMeter', 'ProductionMeterError')}/></td>
                                </tr>

                                {/* Production Meter Array Photos */}
                                {
                                    this.state.ProductionMeterArray.length !== 0 ? 
                                    
                                    this.state.ProductionMeterArray.map(t =>
                                        <tr>
                                            <td className="w-50">
                                                {
                                                    Object.keys(this.state[t]).length === 0 ?
                                                    <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> {t}</div>
                                                    :
                                                    <button className='btn btn-outline text-green btn-text' onClick={() => this.previewImage(this.state[t])}><FontAwesomeIcon icon={faCircle} /> {t}</button>
                                                }
                                            </td>
                                            <td className="w-25"><label for={t} class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id={t} type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], t)} /></td>
                                            <td className="w-25"><label for={t + 'Upload'} class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id={t + 'Upload'} type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], t)}/></td>
                                        </tr>
                                    )
                                    :
                                    <></>
                                }
                                <tr>
                                    <td className="w-50">Add Another Production Meter Pic</td>
                                    <td className="w-25"><button className='btn btn-primary' onClick={() => this.addAnotherPic('ProductionMeterArray', 'ProductionMeter-', '')}>Add <FontAwesomeIcon icon={faPlus} /></button></td>
                                    <td className="w-25"></td>
                                </tr>

                                {/* Production Meter Serial Number Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.ProductionMeterSerialNumber).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Production Meter Serial Number</div>
                                            :
                                            this.state.ProductionMeterSerialNumberError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Production Meter Serial Number: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.ProductionMeterSerialNumber)}><FontAwesomeIcon icon={faCircle} /> Production Meter Serial Number</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="ProductionMeterSerialNumber" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="ProductionMeterSerialNumber" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'ProductionMeterSerialNumber', 'ProductionMeterSerialNumberError')} /></td>
                                    <td className="w-25"><label for="ProductionMeterSerialNumberUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="ProductionMeterSerialNumberUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'ProductionMeterSerialNumber', 'ProductionMeterSerialNumberError')}/></td>
                                </tr>

                                {/* SolarEdge RGM Inverter Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.SolarEdgeRGMInverter).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> SolarEdge RGM Inverter (must show serial number)</div>
                                            :
                                            this.state.SolarEdgeRGMInverterError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading SolarEdge RGM Inverter: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.SolarEdgeRGMInverter)}><FontAwesomeIcon icon={faCircle} /> SolarEdge RGM Inverter (must show serial number)</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="SolarEdgeRGMInverter" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="SolarEdgeRGMInverter" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'SolarEdgeRGMInverter', 'SolarEdgeRGMInverterError')} /></td>
                                    <td className="w-25"><label for="SolarEdgeRGMInverterUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="SolarEdgeRGMInverterUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'SolarEdgeRGMInverter', 'SolarEdgeRGMInverterError')}/></td>
                                </tr>

                                {/* WirsSize Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.WireSize).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Wire Size</div>
                                            :
                                            this.state.WireSizeError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Wire Size: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.WireSize)}><FontAwesomeIcon icon={faCircle} /> Wire Size</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="WireSize" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="WireSize" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'WireSize', 'WireSizeError')} /></td>
                                    <td className="w-25"><label for="WireSizeUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="WireSizeUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'WireSize', 'WireSizeError')}/></td>
                                </tr>

                                {/* CADChanges Photos */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.CADChanges).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> CAD Changes</div>
                                            :
                                            this.state.CADChangesError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading CAD Changes: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.CADChanges)}><FontAwesomeIcon icon={faCircle} /> CAD Changes</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="CADChanges" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="CADChanges" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'CADChanges', 'CADChangesError')} /></td>
                                    <td className="w-25"><label for="CADChangesUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="CADChangesUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'CADChanges', 'CADChangesError')}/></td>
                                </tr>

                                {/* CADChanges Array Photos */}
                                {
                                    this.state.CADChangesArray.length !== 0 ? 
                                    
                                    this.state.CADChangesArray.map(t =>
                                        <tr>
                                            <td className="w-50">
                                                {
                                                    Object.keys(this.state[t]).length === 0 ?
                                                    <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> {t}</div>
                                                    :
                                                    <button className='btn btn-outline text-green btn-text' onClick={() => this.previewImage(this.state[t])}><FontAwesomeIcon icon={faCircle} /> {t}</button>
                                                }
                                            </td>
                                            <td className="w-25"><label for={t} class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id={t} type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], t)} /></td>
                                            <td className="w-25"><label for={t + 'Upload'} class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id={t + 'Upload'} type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], t)}/></td>
                                        </tr>
                                    )
                                    :
                                    <></>
                                }
                                <tr>
                                    <td className="w-50">Add Another CAD Changes Pic</td>
                                    <td className="w-25"><button className='btn btn-primary' onClick={() => this.addAnotherPic('CADChangesArray', 'CADChanges-', '')}>Add <FontAwesomeIcon icon={faPlus} /></button></td>
                                    <td className="w-25"></td>
                                </tr>

                            </tbody>
                        </table>

                        {/* Slack div to send messages */}
                        <div className='py-3'>
                            <button className='btn btn-primary' disabled={this.state.sendingToSlack} onClick={() => this.sendToSlack()}>Notify Office for Review</button>
                        </div>
                        <div className={this.state.slackResponse !== '' ? 'py-3' : 'd-none'}>
                            <p className='text-white'>{this.state.slackResponse}</p>
                        </div>
                        <div className={this.state.sendingToSlack ? 'py-3' : 'd-none'}>
                            <div className={css.PhotoPack__Loader}></div>
                        </div>
                    </div>
                }

                <h2 className={this.state.errorMessage !== '' ? 'text-error' : 'd-none'} style={{ whiteSpace: 'pre-line' }}>Error: {this.state.errorMessage}</h2>

            </div>
        )
    }
};

// ---------- Redux mapping: ----------
const mapStateToProps = state => {
    return {
        user: state.user
    };
};

export default connect(mapStateToProps)(ElectricalPhotoPack);